<template>
  <editor>
    <el-breadcrumb slot="header">
      <el-breadcrumb-item :to="{name: 'news/drafts'}">Drafts</el-breadcrumb-item>
      <el-breadcrumb-item>{{ article.header }}</el-breadcrumb-item>
    </el-breadcrumb>
  </editor>
</template>
<script>
import { mapGetters } from 'vuex'
import Editor from './Editor'

export default {
  components: {
    Editor
  },
  computed: {
    ...mapGetters({
      article: 'drafts/selected'
    })
  },
  created () {
    // beforeEnter guard ensures that the article is already present here
    this.$store.dispatch('draftForm/setModel', this.article)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news/Edit.vue